import { Component, OnInit, Input } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-dp-intergration',
  templateUrl: './dp-intergration.component.html',
  styleUrls: ['./dp-intergration.component.scss']
})
export class DpIntergrationComponent implements OnInit {

  @Input() public dpData: any;

  constructor() { }

  ngOnInit(): void {
  }

  dpIntergrationForm: FormGroup = new FormGroup({
    uniqueId: new FormControl('', [Validators.required]),
    clientKey: new FormControl('', [Validators.required]),

  })

  get f() { return this.dpIntergrationForm.controls; }

}
